import { Component, h } from '@stencil/core';

const COMPONENT_NAME = 'footer-menu-type-1';

/**
 * Footer navigation menu column with a title and vertically stacked link items.
 * Renders a nav element with title slot and items slot for ghost-variant button links.
 * Used as a child component within footer menus slots across all footer types.
 *
 * @category Footers
 * @slot title - <me-text variant="regular" weight="semi-bold">, <me-button variant="ghost">
 * @slot items - {required}, {multiply}, <me-button variant="ghost">, <me-socials showLabels="true">
 * @example
 *   <footer-menu-type-1>
 *     <me-text slot="title" variant="regular" weight="semi-bold">Company</me-text>
 *     <me-button slot="items" variant="ghost" tag="a" href="/about">About Us</me-button>
 *     <me-button slot="items" variant="ghost" tag="a" href="/careers">Careers</me-button>
 *     <me-button slot="items" variant="ghost" tag="a" href="/contact">Contact</me-button>
 *   </footer-menu-type-1>
 */
@Component({
  tag: 'footer-menu-type-1',
  styleUrl: 'index.scss',
  shadow: false,
})
export class FooterMenuType1 {
  render() {
    return (
      <nav class={COMPONENT_NAME}>
        <slot name="title"></slot>
        <div class={`${COMPONENT_NAME}__items`}>
          <slot name="items"></slot>
        </div>
      </nav>
    );
  }
}
